type Case = 'UPPER' | 'LOWER';

export function getLetterCase(base: string): Case {
  return base.toUpperCase() === base ? 'UPPER' : 'LOWER';
}

export function withCase(base: string, casing: Case): string {
  return casing === 'UPPER' ? base.toUpperCase() : base.toLowerCase();
}

export function matchCase(originalChar: string, newChar: string): string {
  return originalChar.toUpperCase() !== originalChar ? newChar.toLowerCase() : newChar.toUpperCase();
}
